import { render, staticRenderFns } from "./CampaignDates.vue?vue&type=template&id=5684e2bb&"
import script from "./CampaignDates.vue?vue&type=script&lang=js&"
export * from "./CampaignDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports